import Component from '@glimmer/component';
import { service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';

export default class DeluxePlayerScheduleItemComponent extends Component {
  @service feeds;
  @service stereo;

  @tracked showLoading = false;
  @tracked _feed;

  constructor() {
    super(...arguments);

    if (this.args.airing) {
      this._feed = this.feeds.buildFeed(this.args.airing);
    }
  }

  get feed() {
    return this.args.feed || this._feed;
  }

  get identifier() {
    return this.feed?.identifier;
  }

  showLoadingTask = task(async () => {
    this.showLoading = true;

    await timeout(500);

    this.showLoading = false;
  });

  handlePlayTask = task(async () => {
    if (this.feed.canPlay) {
      this.showLoadingTask.perform();

      await this.feed.playPauseTask.unlinked().perform(this.args.startTime);
    }
  });
}
